import React from 'react';
import * as fileCrud from '../../../../crud/file.crud';
import Document from '../../_CustomComponents/DocumentV2';
import QuoteCustomForm from './CustomForm';
import BaseDocument from '../../_CustomComponents/BaseDocument';
import moment from 'moment';
import { injectIntl } from "react-intl";
import DocumentDraftInfo from '../../_CustomComponents/DocumentDraftInfo';



// export const effectTypes = [
//     { value: 'noeffect', display: 'There is no effect on the Accepted Programme' },
//     { value: 'mitigated', display: 'There is an effect on the Accepted Programme but this has been mitigated by measures as detailed' },
//     { value: 'notmitigated', display: 'There is an effect on the Accepted Programme which we are unable to mitigate' },
// ];
// export const effectTypesNoProgramReply = [
//     { value: 'noeffect', display: 'There is no effect on the Programme' },
//     { value: 'mitigated', display: 'There is an effect on the Programme but this has been mitigated by measures as detailed' },
//     { value: 'notmitigated', display: 'There is an effect on the Programme which we are unable to mitigate' },
// ]

class QuoteDocument extends BaseDocument {
    renderForm = () => {
        return (
            <QuoteCustomForm
                {...this.props}
                compensationReference={(this.props.compensation || {}).referenceid}
                item={this.props.notification}
                valueChangeHandler={this.props.fieldChanged}
                customFields={(this.props.customFieldsCommon || {}).QUOTE}
            />
        );
    }
    uploadFile = (data, config) => {
        const { companyid, projectid, contractid } = this.props.contract;
        return fileCrud.uploadContractNotificationFiles(companyid, projectid, contractid, this.props.documentType, this.props.notification.quotationid, this.props.workflowItem.id, this.props.workflowItem.config.quotationWorkflowID, data, config)
    }


    render() {
        const documentIsFinal = this.props.notification.showtasknotification === 1;
        const { createby, createdate, lastdraftedbyname, lastdrafteddate, lastdraftednotifiedtoname } = this.props.notification;

        return (
            <>
                <DocumentDraftInfo
                    documentIsFinal={documentIsFinal}
                    createbyname={createby}
                    createdate={createdate}
                    lastdraftedbyname={lastdraftedbyname}
                    lastdrafteddate={lastdrafteddate}
                    lastdraftednotifiedtoname={lastdraftednotifiedtoname}
                />
                <Document
                    key={this.props.notification.referenceid + documentIsFinal}
                    docConfig={this.props.notification.pdfjsoncontent}
                    isFinal={documentIsFinal}
                    printDivRef={this.props.printDivRef}
                    workflowItem={this.props.workflowItem}
                    contract={this.props.contract}
                    reference={this.props.notification.compensationreference}
                    form={documentIsFinal ? null : this.renderForm()}
                    uploadMethod={documentIsFinal ? null : this.uploadFile}
                    files={this.props.files}
                    notificationid={this.props.notificationid}
                    documentType={this.props.documentType}
                    customFields={(this.props.customFieldsCommon || {}).QUOTE}
                    customFieldValues={this.props.notification.customfieldvalues}
                    assetid={this.props.compensation.assetid}
                    saving={this.props.saving}
                    onFileUploadFinish={this.props.onFileUploadFinish}
                    onFileUploadStart={this.props.onFileUploadStart}
                    quoteref={this.props.notification.referenceid}
                />
            </>

        );
    }
}

export default injectIntl(QuoteDocument);
